module.exports = __webpack_public_path__ + "assets/img/guide_jianshe.990c7ad3.png";